/** @format */

export default {
  /**
   * application flows
   */
  flows: {
    broker: 'broker',
    common: 'common'
  },
  /**
   * flowOrigins to identify the source of the flow
   */
  flowOrigins: {
    broker: 'broker',
    common: 'common'
  },
  /**
   * views represent every single page in the application excluding modals
   */
  views: {
    page_not_found: 'page_not_found',
    dashboard: 'dashboard',
    login: 'login',
    changePassword: 'changePassword',
    broker_profile: 'broker_profile',
    object_listing: 'object_listing',
    object_view_images: 'object_view_images'
  },
  colors: {
    /**
     * this object would represent the classNames of colors instead of the actual color
     **/

    white: 'btn-white',
    pink: 'btn-pink'
  }
};
